import React, { useEffect, useState } from "react";
import {
  _goToSaleReport,
  _goToSellerReport,
  _goToProductReport,
  _goToCustomerReport,
} from "routers/helper";

import { TouchableOpacity, View } from "react-native";
import {
  Error,
  GridView,
  Header,
  Icon,
  ImgIcon,
  Loading,
  Shadow,
  TabHeader,
  Text,
} from "components";

import { colors, sizes, strings } from "assets/constants";
import { icons } from "assets/icons";
import css from "styles";
import { countKFormatter, sn } from "utils";
import { useReports } from "clients/apis";
import { useIsFocused } from "@react-navigation/native";
import WebView from "react-native-webview";
import WebViewProgress from "../details/WebViewProgress";
import { useRecoilValue } from "recoil";
import { userAtom } from "stores";
import tinycolor from "tinycolor2";

export default function Reports() {
  const { color } = useRecoilValue(userAtom);
  const isFocused = useIsFocused();
  const { isLoading, data, refetch, isError, error, isRefetching } =
    useReports();

  const [progress, setProgress] = useState<number | null>(0);
  // const webViewH = useRef(new Animated.Value(0)).current;

  const [webViewH, setWebViewH] = useState<number>(200);

  useEffect(() => {
    isFocused && refetch();
  }, [refetch, isFocused]);

  const _renderContent = () => {
    if (isLoading) {
      return <Loading style={{ marginTop: 20 }} />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    return (
      <>
        <GridView
          maxWidth={700}
          data={[
            {
              title: strings.sellers,
              count: countKFormatter(data?.data.sellers?.count),
              onPress: () => _goToSellerReport(data?.data.sellers?.link),
              colors: colors.sellerReports,
              countLabel: strings.manager,
              subtitle: strings.sellers_reports,
              icon: icons.sellers,
            },
            {
              count: countKFormatter(data?.data.factors?.count),
              onPress: () => _goToSaleReport(data?.data.factors?.link),
              colors: colors.saleReports,
              countLabel: strings.sale,
              title: strings.sales,
              subtitle: strings.factor_reports,
              icon: icons.sales,
            },
            {
              count: countKFormatter(data?.data.products?.count),
              onPress: () => _goToProductReport(data?.data.products?.link),
              colors: colors.productReports,
              countLabel: strings.product,
              title: strings.products,
              subtitle: strings.product_reports,
              icon: icons.products,
            },
            {
              count: countKFormatter(data?.data.customers?.count),
              onPress: () => _goToCustomerReport(),
              colors: colors.customerReports,
              countLabel: strings.customer,
              title: strings.customers,
              subtitle: strings.customer_reports,
              icon: icons.customers,
            },
          ]}
          numberOfCol={sn(4, 5, 6, 8)}
          renderItem={(item) => {
            return (
              <TouchableOpacity
                activeOpacity={sizes.tapOpacity}
                onPress={item.onPress}
                style={{
                  width: "100%",
                  height: "100%",
                }}
              >
                <Shadow
                  style={{
                    padding: 2,
                    width: "100%",
                    height: "100%",
                    backgroundColor: colors.white,
                    borderRadius: sizes.radius.xl,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Text size={"sm"} weight="extraBold">
                    {item.title}
                  </Text>
                  <View
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: 32,
                      backgroundColor: tinycolor(colors.theme)
                        .lighten(60)
                        .toString(),
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: 6,
                    }}
                  >
                    <Text
                      color={tinycolor(colors.theme).darken(15).toString()}
                      weight="extraBold"
                    >
                      {item.count}
                    </Text>
                  </View>
                </Shadow>
              </TouchableOpacity>
            );
          }}
        />
        <WebView
          style={{ height: sizes.screenH }}
          nestedScrollEnabled
          scrollEnabled={false}
          javaScriptEnabled={true}
          domStorageEnabled={true}
          automaticallyAdjustContentInsets={false}
          source={{ uri: data?.data?.chart_view }}
          onMessage={(event) => setWebViewH(Number(event.nativeEvent.data))}
          injectedJavaScript="window.ReactNativeWebView.postMessage(document.body.scrollHeight)"
          onLoadProgress={(e) =>
            setProgress(
              e.nativeEvent.progress === 1 ? null : e.nativeEvent.progress
            )
          }
        />
      </>
    );
  };

  return (
    <>
      <Header title={strings.reports} />
      {_renderContent()}
    </>
  );
}
